import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Divider } from 'antd';

import messages from '../messages';

function TooltipQuestionLabel({
  itemIndex,
  qLabel,
  endOfSurvey,
  reason,
  goesToEndGroup,
}) {
  if (endOfSurvey) {
    return (
      <span className="text-weight-bold">
        {itemIndex > 0 && (
          <Divider
            type="vertical"
            className="margin-horizontal-xxs margin-right-none background-grey-7"
          />
        )}
        <FormattedMessage {...messages.endOfSurvey} />
        {reason && (
          <React.Fragment>
            {' '}
            (
            <FormattedMessage {...messages.endOfSurveyReason[reason]} />)
          </React.Fragment>
        )}
      </span>
    );
  }
  return (
    <span>
      {itemIndex > 0 && (
        <Divider
          type="vertical"
          className="margin-horizontal-xxs margin-right-none background-grey-7"
        />
      )}

      <span className="font-bold">
        {goesToEndGroup ? `${qLabel} end` : qLabel}
      </span>
    </span>
  );
}

TooltipQuestionLabel.propTypes = {
  itemIndex: PropTypes.number,
  qIndex: PropTypes.number,
  endOfSurvey: PropTypes.bool,
  reason: PropTypes.string,
};

export default TooltipQuestionLabel;
